import { CHANGE_CHANNELS_TYPE } from 'ChannelsTabs/constants'
import type { ChannelsType } from 'ChannelsTabs/types'
import { CHANGE_DATE } from 'DatePickerDialog/constants'
import type { Expanded } from 'expanded/types'
import { TOGGLE_LIST_DETAILS } from 'ListDetails/constants'
import type { Action } from 'redux'
import { emptyObject } from 'utils'

import { TOGGLE_EXPANDED } from './constants'

const initialState = {
  group: null,
  channels: null,
  countries: null,
  'countries-channels': null,
  'countries-saleTypes': null,
  'countries-countries': null,
  'countries-owners': null,
  owners: null,
  saleTypes: null,
}

interface ReducerAction extends Action {
  payload: Partial<Expanded & { channelsType?: ChannelsType }>
}

export default function expanded(state: Expanded = initialState, { payload, type }: ReducerAction) {
  switch (type) {
    case TOGGLE_EXPANDED:
      return {
        ...(payload.group ? initialState : state),
        ...(!payload.group ? { group: initialState.group } : emptyObject),
        ...payload,
      }

    case CHANGE_DATE:
    case CHANGE_CHANNELS_TYPE:
      return initialState

    case TOGGLE_LIST_DETAILS:
      return {
        ...initialState,
        [payload.channelsType!]: state[payload.channelsType!],
      }

    default:
      return state
  }
}
